export { InformativeBannerComponent } from './informative-banner.component';
export { InformativeBannerService } from './informative-banner.service';
